const dashboard_de = {
  title: 'Dashboard',
  searchPlaceholder: 'Dashboard durchsuchen...',

  // Section 1 — My Trade Shows
  myTradeShows: 'Meine Messen',
  ongoing: 'Laufend',
  upcoming: 'Bevorstehend',
  past: 'Vergangen',
  events: 'Veranstaltungen',

  // Section 2 — Next Event
  nextEvent: 'Nächste Veranstaltung',
  location: 'Ort',
  dateRange: 'Datum',
  countdown: 'Tage bis zum Aufbau',
  daysRemaining: '{count} Tage',
  boothNumber: 'Standnummer',
  boothNotAssigned: 'Noch nicht zugewiesen',
  exhibitsAssigned: 'Zugewiesene Artikel',
  planningComplete: 'Planung abgeschlossen',
  dataMissing: 'Daten fehlen',
  viewDetails: 'Details anzeigen',
  noUpcomingEvent: 'Keine bevorstehenden Veranstaltungen',
  noUpcomingEventHint: 'Planen Sie Ihre nächste Messe, um zu beginnen.',
  createNewPlan: 'Neuen Plan erstellen',

  // Section 3 — Open Tasks
  openTasks: 'Offene Aufgaben',
  noOpenTasks: 'Keine offenen Aufgaben — alles erledigt.',
  taskIncompletePlan: 'Unvollständiger Messeplan',
  taskUnassignedExhibits: 'Artikel nicht zugewiesen',
  taskPendingInvitation: 'Ausstehende Team-Einladung',
  due: 'Fällig',

  // Section 4 — Master Data
  masterDataStatus: 'Stammdaten',
  activeProjects: 'Aktive Projekte',
  exhibits: 'Artikel',
  categories: 'Kategorien',
  teamMembers: 'Teammitglieder',

  // Section 5 — Quick Actions
  quickActions: 'Schnellaktionen',
  createNewExhibit: 'Neuen Artikel erstellen',
  inviteTeamMember: 'Teammitglied einladen',

  // Legacy
  future: 'Zukünftig',
  currentlyTakingPlace: 'Derzeit im Vorgang',
  fairs: 'Fahrten',
  exhibitionOverview: 'Ausstellungsübersicht',
  organisationOverview: 'Organisationsübersicht',
}

export default dashboard_de
